export default {"src":"/_next/static/media/buzzfeed.722f87e1.svg","height":60,"width":120,"blurWidth":0,"blurHeight":0};